import React, { Component } from 'react'
import './PollButton.css'
import { Auth } from '../../../../helpers'
import YesNoButtons from './YesNoButtons'
import ScalingButtons from './ScalingButtons'
import OpenAnswer from './OpenAnswer'

export default class PollButton extends Component {
  constructor (props) {
    super(props)

    this.handleVoting = this.handleVoting.bind(this)
  }

  handleVoting (vote) {
    if (this.props.onAnswer && this.props.locked !== vote && !Auth.isAdmin()) {
      this.props.onAnswer.call(null, vote)
    }
  }

  render () {
    const { poll } = this.props
    const myVote = poll.votes && poll.votes.find(v => v.participant === Auth.getParticipant())

    return (
      <div className='poll-button-wrap'>
        <div className='poll-button-inner'>
          {poll.pollType === 'yes-no' &&
            <YesNoButtons myVote={myVote} handleVoting={this.handleVoting} />}
          {poll.pollType === 'scaling' &&
            <ScalingButtons myVote={myVote} handleVoting={this.handleVoting} />}
          {poll.pollType === 'open' &&
            <OpenAnswer myVote={myVote} handleVoting={this.handleVoting} />}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/dashboard/chat/buttons/PollButton.js